import {
  initializeTelemetry,
  OneDsTelemetrySinkFactory,
  ConsoleTelemetrySinkFactory,
  ITelemetry
} from '@iamexperiences/ecos-telemetry';
import { auth } from '../auth';
import { settingsManager } from '../shared/settings';
import { v4 as uuidv4 } from 'uuid';
import { experimentClient } from '../Experiment/experimentClient';

const ONE_DS_CONSOLE_QUERY_STRING = '1dsConsole';

const isConsolePrintingEnabled = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const isEnabled = queryParameters.get(ONE_DS_CONSOLE_QUERY_STRING);
  return isEnabled === 'true';
};

const sinkFactories = [
  OneDsTelemetrySinkFactory({
    instrumentKey: settingsManager.get('oneDSInstrumentKey') || '',
    enableNetworkCallTracking: true,
    enableConsolePrinting: isConsolePrintingEnabled(),
    enablePublishTelemetry: process.env.NODE_ENV === 'production',
    endpointUrl: settingsManager.get('defaultCollectorEndpoint'),
  }),
];

if (process.env.NODE_ENV === 'development') {
  sinkFactories.push(ConsoleTelemetrySinkFactory());
}

const euSinkFactories = [
  OneDsTelemetrySinkFactory({
    instrumentKey: settingsManager.get('oneDSInstrumentKey') || '',
    enableNetworkCallTracking: true,
    enableConsolePrinting: isConsolePrintingEnabled(),
    enablePublishTelemetry: process.env.NODE_ENV === 'production',
    endpointUrl: settingsManager.get('euCollectorEndpoint') ?? settingsManager.get('defaultCollectorEndpoint'),
  }),
];

if (process.env.NODE_ENV === 'development') {
  euSinkFactories.push(ConsoleTelemetrySinkFactory());
}

export const defaultTelemetry = initializeTelemetry({
  sinkFactories,
  data: () => {
    return {
      latestAuthEventType: auth.latestAuthEventType,
      userId: auth.user?.objectId,
      tenantId: auth.user?.tenantId,
      namespace: 'AadMyAccount',
      env: settingsManager.get('env') ?? 'others',
      buildVersion: process.env.VERSION,
      assignmentContext: experimentClient.getAssignmentContext(),
      logId: uuidv4(),
    };
  },
});

export const euTelemetry = initializeTelemetry({
  sinkFactories: euSinkFactories,
  data: () => {
    return {
      latestAuthEventType: auth.latestAuthEventType,
      userId: auth.user?.objectId,
      tenantId: auth.user?.tenantId,
      namespace: 'AadMyAccount',
      env: settingsManager.get('env') ?? 'others',
      buildVersion: process.env.VERSION,
    };
  },
});

let telemetry = euTelemetry;

export function getTelemetry() {
  return telemetry;
}

export function updateTelemetryReference(updatedTelemetry: ITelemetry) {
  telemetry = updatedTelemetry;
}
